import React from 'react';
import { styled } from 'linaria/react'
import ListCardSkeleton from './ListCardSkeleton';

const n = 6;
const BrandlistSkeletonContainer = styled.div`
    ul {
        list-style-type: none;
    }

    .list-div {
        width: 160px;
        height: 24px;
    }
`

const BrandlistSkeleton = () => {
    return (
       <div className=" px-128">
          <BrandlistSkeletonContainer className="row py-32 m-0">
             <div className="col-3 col-md-2 p-0">
                <div className="ratio ratio-1x1 placeholder placeholder-wave"></div>
             </div>
             <div className="col-9 col-md-10">
                <div className="row">
                   {[...Array(n)].map((e, i) => (
                    <div className="col-12 col-sm-6 col-lg-4 col-xl-2" key={i}>
                            <ul>
                                <li>
                                    <div className="list-div placeholder placeholder-wave mb-2"></div>
                                    <div className="list-div placeholder placeholder-wave my-2"></div>
                                    <div className="list-div placeholder placeholder-wave my-2"></div>
                                </li>
                            </ul>
                        </div>
                   ))}
                </div>
             </div>
          </BrandlistSkeletonContainer>
          <BrandlistSkeletonContainer className="row py-32 m-0">
             <div className="col-3 col-md-2 p-0">
                <div className="ratio ratio-1x1 placeholder placeholder-wave"></div>
             </div>
             <div className="col-9 col-md-10">
                <div className="row">
                   {[...Array(n)].map((e, i) => (
                    <div className="col-12 col-sm-6 col-lg-4 col-xl-2" key={i}>
                            <ul>
                                <li>
                                    <div className="list-div placeholder placeholder-wave mb-2"></div>
                                    <div className="list-div placeholder placeholder-wave my-2"></div>
                                    <div className="list-div placeholder placeholder-wave my-2"></div>
                                </li>
                            </ul>
                        </div>
                   ))}
                </div>
             </div>
          </BrandlistSkeletonContainer>
          <BrandlistSkeletonContainer className="row py-32 m-0">
             <div className="col-3 col-md-2 p-0">
                <div className="ratio ratio-1x1 placeholder placeholder-wave"></div>
             </div>
             <div className="col-9 col-md-10">
                <div className="row">
                   {[...Array(n)].map((e, i) => (
                    <div className="col-12 col-sm-6 col-lg-4 col-xl-2" key={i}>
                            <ul>
                                <li>
                                    <div className="list-div placeholder placeholder-wave mb-2"></div>
                                    <div className="list-div placeholder placeholder-wave my-2"></div>
                                    <div className="list-div placeholder placeholder-wave my-2"></div>
                                </li>
                            </ul>
                        </div>
                   ))}
                </div>
             </div>
          </BrandlistSkeletonContainer>
       </div>
    )
}
 
export default BrandlistSkeleton;